import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { resolveHidden, toggleHiddenKey } from '../lib/tabVisibility';

interface TabVisibilityStore {
  hidden: Record<string, string[]>;
  isTabHidden: (viewId: string, tabKey: string, defaultHidden?: string[]) => boolean;
  toggleTab: (viewId: string, tabKey: string, defaultHidden?: string[]) => void;
  setHidden: (viewId: string, keys: string[]) => void;
}

export const useTabVisibilityStore = create<TabVisibilityStore>()(
  persist(
    (set, get) => ({
      hidden: {},

      isTabHidden: (viewId, tabKey, defaultHidden) => {
        return resolveHidden(get().hidden[viewId], defaultHidden).includes(tabKey);
      },

      toggleTab: (viewId, tabKey, defaultHidden) => {
        set((state) => {
          const next = toggleHiddenKey(state.hidden[viewId], tabKey, defaultHidden);
          return { hidden: { ...state.hidden, [viewId]: next } };
        });
      },

      setHidden: (viewId, keys) => {
        set((state) => ({
          hidden: { ...state.hidden, [viewId]: keys },
        }));
      },
    }),
    {
      name: 'cime.tabs.visibility',
      partialize: (state) => ({ hidden: state.hidden }),
    },
  ),
);
